module.exports = require('./helpers/bundle-url').getBundleURL('aK4Nu') + "BTCLogo.5558c6c7.svg";